module.exports = __webpack_public_path__ + "img/s3-1.c84b390a.jpg";